import { ChevronDownSmall, ChevronUpDown, ChevronUpSmall } from "components/icons/generated";
import { AriaSort } from "types/Aria";
import { SearchQueryOrderDirection } from "types/generated";

import { TableColumnMeta } from "../types";

export const getSortIcon = (sortDirection: SearchQueryOrderDirection | undefined) => {
  if (sortDirection === SearchQueryOrderDirection.Desc) {
    return ChevronDownSmall;
  }

  if (sortDirection === SearchQueryOrderDirection.Asc) {
    return ChevronUpSmall;
  }

  return ChevronUpDown;
};

export const getAriaSort = (sortDirection: SearchQueryOrderDirection | undefined): AriaSort => {
  if (sortDirection === SearchQueryOrderDirection.Asc) {
    return "ascending";
  }

  if (sortDirection === SearchQueryOrderDirection.Desc) {
    return "descending";
  }

  return "none";
};

export const reorderColumns = <Columns extends string>(
  columns: Columns[],
  columnId: Columns,
  direction: "left" | "right"
) => {
  const currentIndex = columns.indexOf(columnId);
  const newIndex = direction === "left" ? currentIndex - 1 : currentIndex + 1;

  const newColumnOrder = [...columns];
  newColumnOrder.splice(currentIndex, 1);
  newColumnOrder.splice(newIndex, 0, columnId);
  return newColumnOrder;
};

// Hiding the anchored column counts as displacing it: the position's meaning would be left with no
// column to carry it. Every order change goes through this — a move onto it, a pin, a drag in the
// settings drawer.
export const withAnchoredColumnFirst = <Columns extends string>(
  order: { visible: Columns[]; hidden: Columns[] },
  anchoredColumn: Columns | undefined
): { visible: Columns[]; hidden: Columns[] } => {
  const tableHasAnchoredColumn =
    !!anchoredColumn &&
    (order.visible.includes(anchoredColumn) || order.hidden.includes(anchoredColumn));

  if (!tableHasAnchoredColumn || order.visible[0] === anchoredColumn) {
    return order;
  }

  return {
    visible: [anchoredColumn, ...order.visible.filter((columnId) => columnId !== anchoredColumn)],
    hidden: order.hidden.filter((columnId) => columnId !== anchoredColumn),
  };
};

export const getHeadColumnKey = (column: TableColumnMeta) => `thead-column-${column.id}`;
